/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';

// This is a controlled component: the caller owns `@isDialogOpen` and is
// responsible for clearing it from `@submitConfirm` / `@cancelConfirm`.
// It deliberately does not close itself - `@isDialogOpen` is a one-way
// argument, so setting it here would hide the dialog locally while leaving the
// caller's flag stuck open (and callers that toggle that flag would then need
// two clicks to reopen).
export default class ConfirmationDialog extends Component {
  // Overridable no-op defaults; callers pass their own via `@submitConfirm` /
  // `@cancelConfirm`. These must stay plain (undecorated) so they remain
  // writable when the component is created with those arguments.
  submitConfirm() {}
  cancelConfirm() {}

  @action
  handleSubmitConfirm() {
    this.submitConfirm();
  }

  @action
  handleCancelConfirm() {
    this.cancelConfirm();
  }
}
